import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"font-weight-bold pb-1 mr-5"},[_vm._v("Bruk som standard betalingsmåte")]),_c(VSwitch,{attrs:{"color":"primary","readonly":""},on:{"click":function($event){return _vm.$emit('update', 5)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }